import React, { Fragment } from 'react';
import classNames from 'classnames';

import { IMessage } from '@sv-support-sdk/shared-types/src/common/tickets';
import Divider from '@sv-support-sdk/ui-components/src/components/Content/Divider';

import Message from './Message';

import useMobileDetect from '../../../hooks/useMobileDetect';

import css from '../style.module.scss';

interface IProps {
  messages: IMessage[];
}

const MessageList = ({ messages }: IProps) => {
  const isMobile = useMobileDetect();

  return (
    <div className={css.messageList}>
      {messages.map((message, idx) => {
        return (
          <Fragment key={message.id}>
            <Message message={message} />
            {idx + 1 === messages.length ? null : (
              <div
                className={classNames(css.messageList__divider, {
                  [css.isMobile]: isMobile,
                })}
              >
                <Divider indents="24-0" />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default MessageList;
